import { create } from "zustand"

export const useColorStore = create((set) => ({
    body: "#ffffff",
    cap: "#ffffff",
    currentCustomizedPart: "body",
    isVisible: false,
    assignBody: (newColor) => set((state) => ({ body: newColor })),
    assignCap: (newColor) => set((state) => ({ cap: newColor })),
    toggleVisibility: (newCustomizedPart) => set((state) => ({ isVisible: !state.isVisible, currentCustomizedPart: newCustomizedPart }))
}))
